export default {
  hero: {
    title: '종합 고객 지원 서비스',
    subtitle: '요구사항 정리부터 지속적인 최적화까지 전 주기 전문 지원을 제공하여 비즈니스의 안정적인 운영을 보장합니다'
  },
  serviceProcess: {
    title: '서비스 프로세스',
    steps: {
      step1: {
        title: '요구사항 파악',
        description: '비즈니스 요구를 깊이 이해하고 전문적인 자문을 제공합니다'
      },
      step2: {
        title: '솔루션 설계',
        description: '업무 요구에 맞춘 맞춤형 솔루션을 설계합니다'
      },
      step3: {
        title: '구축 및 도입',
        description: '전문 팀이 효율적인 구현과 원활한 배포를 보장합니다'
      },
      step4: {
        title: '운영 지원',
        description: '24x7 모니터링과 신속한 문제 대응'
      },
      step5: {
        title: '최적화 및 업그레이드',
        description: '지속적인 성능 개선과 업그레이드 제안을 제공합니다'
      }
    }
  },
  helpCenter: {
    title: '헬프 센터',
    categories: {
      title: 'FAQ 카테고리',
      service: '서비스 문의',
      trouble: '문제 신고',
      compliance: '컴플라이언스 문의',
      technical: '기술 지원',
      account: '계정 관리'
    },
    needMoreHelp: '추가 도움이 필요하신가요?',
    onlineSupport: '온라인 고객 지원',
    searchPlaceholder: '헬프 센터 검색...',
    faq: {
      service: {
        title: '서비스 문의',
        q1: {
          question: 'Global Data는 어떤 기술 지원 서비스를 제공하나요?',
          answer: {
            intro: 'Global Data는 다음과 같은 종합 기술 지원 서비스를 제공합니다:',
            list: [
              '24x7 시스템 모니터링 및 사고 대응',
              '원격 기술 지원 및 문제 진단',
              '정기 시스템 상태 점검 및 성능 최적화',
              '보안 취약점 진단 및 개선 권고',
              '시스템 업그레이드 및 이전 지원',
              '맞춤형 교육 서비스'
            ],
            conclusion: '고객 요구에 따라 기본 지원부터 전담 엔터프라이즈 지원팀까지 다양한 서비스 등급을 제공합니다.'
          }
        },
        q2: {
          question: '신규 서비스를 신청하거나 기존 서비스를 업그레이드하려면 어떻게 해야 하나요?',
          answer: {
            intro: '다음 경로를 통해 신청하실 수 있습니다:',
            list: [
              '고객 관리 플랫폼에 로그인하여 "서비스 관리" 페이지에서 신청',
              '{serviceEmail}로 요구사항을 이메일 발송',
              '고객 지원 핫라인 400-123-4567로 문의',
              '온라인 고객 지원 시스템을 통한 실시간 상담'
            ],
            conclusion: '당사 서비스 팀이 영업일 기준 1일 이내에 연락드려 상세 요구와 구현 방안을 협의합니다.'
          }
        },
        q3: {
          question: '서비스 계약 기간은 얼마나 되며, 갱신은 어떻게 하나요?',
          answer: {
            intro: '표준 서비스 계약은 1년 단위이며, 만료 30일 전에 갱신 안내를 드립니다. 갱신 절차는 다음과 같습니다:',
            list: [
              '고객 관리 플랫폼에서 갱신 옵션 확인',
              '서비스 내용과 가격 확인',
              '전자 계약 온라인 서명',
              '결제 완료'
            ],
            conclusion: '장기 파트너에게는 우대 요금과 추가 서비스 혜택이 제공됩니다.'
          }
        }
      },
      trouble: {
        title: '문제 신고',
        content: '문제 신고 관련 FAQ 내용이 여기에 표시됩니다...'
      },
      compliance: {
        title: '컴플라이언스 문의',
        content: '컴플라이언스 문의 관련 FAQ 내용이 여기에 표시됩니다...'
      },
      technical: {
        title: '기술 지원',
        content: '기술 지원 관련 FAQ 내용이 여기에 표시됩니다...'
      },
      account: {
        title: '계정 관리',
        content: '계정 관리 관련 FAQ 내용이 여기에 표시됩니다...'
      }
    },
    instantHelp: {
      title: '즉시 도움이 필요하신가요?',
      subtitle: '기술 지원 팀이 바로 도와드립니다',
      hotline: '서비스 핫라인',
      hotlineValue: '400-123-4567',
      email: '이메일',
      emailLocalPart: 'support',
      serviceTime: '서비스 시간',
      serviceTime24x7: '24x7',
      contactSupport: '기술 지원 문의'
    }
  },
  sla: {
    title: '서비스 수준 협약(SLA)',
    description: '고객의 요구 수준에 맞는 서비스 보장 체계를 제공합니다. 아래는 SLA 개요이며, 상세 SLA 문서는 담당 계정 매니저를 통해 확인하실 수 있습니다.',
    table: {
      serviceItem: '서비스 항목',
      enterprise: '엔터프라이즈',
      professional: '프로페셔널',
      standard: '스탠다드',
      responseTime: '응답 시간',
      criticalResolution: '심각 장애 해결 시간',
      generalResolution: '일반 장애 해결 시간',
      availability: '시스템 가용성',
      supportMethod: '지원 방식',
      supportMethod_enterprise: '전화 + 원격 + 현장',
      supportMethod_professional: '전화 + 원격',
      supportMethod_standard: '원격 지원',
      accountManager: '전담 계정 매니저',
      compensation: '보상(서비스 중단)',
      compensation_enterprise: '서비스 기간 × 50',
      compensation_professional: '서비스 기간 × 30',
      compensation_standard: '서비스 기간 × 10',
      values: {
        responseTime: { enterprise: '15분', professional: '1시간', standard: '4시간' },
        criticalResolution: { enterprise: '2시간', professional: '8시간', standard: '24시간' },
        generalResolution: { enterprise: '8시간', professional: '24시간', standard: '48시간' },
        availability: { enterprise: '99.99%', professional: '99.9%', standard: '99.5%' }
      }
    },
    levels: {
      enterprise: {
        title: '엔터프라이즈 서비스',
        description: '핵심 비즈니스 시스템을 위한 최고 수준의 보장 체계로, 시스템 안정성 요구가 매우 높은 대기업에 적합합니다.',
        features: [
          '24x7 전담 지원팀',
          '15분 이내 신속 대응',
          '현장 지원 서비스',
          '분기별 시스템 헬스 체크'
        ],
        learnMore: '더 알아보기'
      },
      professional: {
        title: '프로페셔널 서비스',
        description: '중대형 기업의 핵심 업무 시스템을 위한 종합 보장 체계입니다.',
        features: [
          '평일 8x12시간 지원',
          '1시간 응답',
          '원격 우선 지원',
          '반기별 시스템 헬스 체크'
        ],
        learnMore: '더 알아보기'
      },
      standard: {
        title: '스탠다드 서비스',
        description: '일반 업무 시스템을 위한 기본 보장 체계로, 소규모 기업 또는 비핵심 시스템에 적합합니다.',
        features: [
          '평일 8시간 지원',
          '4시간 응답',
          '원격 지원 서비스',
          '연 1회 시스템 헬스 체크'
        ],
        learnMore: '더 알아보기'
      }
    }
  },
  feedback: {
    title: '사후 피드백 및 불만 접수',
    subtitle: '서비스 평가 기능은 제거되었습니다. 문제 제기, 제안, 불만 접수가 필요하시면 아래 채널을 이용해 주세요. 신속히 후속 대응하겠습니다.',
    evaluation: {
      title: '서비스 평가',
      subtitle: '고객의 의견은 서비스 품질 개선에 매우 중요합니다',
      serviceType: '서비스 유형',
      serviceTypePlaceholder: '서비스 유형을 선택해 주세요',
      serviceTypes: {
        technical: '기술 지원',
        consulting: '컨설팅 서비스',
        implementation: '구축',
        training: '교육 서비스',
        other: '기타 서비스'
      },
      satisfaction: '전반적 만족도',
      detailedFeedback: '상세 피드백',
      feedbackPlaceholder: '서비스 경험과 개선 제안을 자세히 작성해 주세요...',
      acceptNotification: '향후 서비스 개선 관련 안내 수신에 동의합니다',
      submit: '평가 제출',
      successMessage: '소중한 의견 감사합니다. 신중히 검토하겠습니다.'
    },
    complaint: {
      title: '피드백 및 불만 접수 채널',
      subtitle: '구축, 운영, 대응, 커뮤니케이션 과정에서 이슈 제기나 에스컬레이션이 필요하시면 아래 채널을 이용해 주세요. 서비스 시간 내 최대한 빠르게 회신드립니다.',
      hotline: {
        title: '불만 접수 핫라인',
        phone: '400-123-4567 ext. 8',
        time: '서비스 시간: 평일 9:00-18:00'
      },
      email: {
        title: '불만 접수 이메일',
        localPart: 'complaint',
        response: '이메일 접수 후 24시간 이내 회신드립니다'
      },
      online: {
        title: '온라인 불만 접수',
        description: '고객 관리 플랫폼에서 불만 접수 양식을 제출할 수 있습니다',
        tracking: '처리 진행 상황을 실시간으로 확인할 수 있습니다'
      },
      process: {
        title: '불만 처리 절차',
        steps: [
          '피드백 또는 불만 내용 접수',
          '고객 지원에서 접수 확인(24시간 이내)',
          '관련 부서 조사 진행',
          '해결 방안 또는 처리 계획 안내',
          '고객의 처리 결과 확인'
        ]
      }
    }
  },
  cta: {
    title: '추가 지원이 필요하신가요?',
    subtitle: '고객 지원 팀이 전문 서비스를 제공하고 당면한 문제 해결을 도와드립니다',
    contactSupport: '고객 지원 문의',
    viewDocumentation: '도움말 문서 보기'
  },
  chat: {
    title: '온라인 고객 지원',
    placeholder: '질문을 입력해 주세요...',
    welcome: '안녕하세요. 지능형 고객 지원 어시스턴트입니다. 무엇을 도와드릴까요?',
    assistant: '고객 지원',
    me: '나',
    justNow: '방금',
    autoReply: '문의해 주셔서 감사합니다. 고객 지원 담당자가 곧 답변드리겠습니다.'
  }
}
